import { SectionMessage, Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { cegidIntegrationStatusToIcon } from '@features/cegidIntegration/constants/cegidIntegrationStatusToIcon'
import { cegidIntegrationStatusToTranslationKeys } from '@features/cegidIntegration/constants/cegidIntegrationStatusToTranslationKeys'
import { useUserOrganization } from '@modules-deprecated/app/organization'
import { useBillIntegrationStatusMessageKey } from '@views/bills/hooks/useBillIntegrationStatusKey'

import { cegidIntegrationStatusToMessageVariant } from '../../constants/cegidIntegrationStatusToMessageVariant'
import { getLatestIntegrationStatus } from '../../utils/getLatestIntegrationStatus'
import { useBillView } from '../BillReadableForm'
import { BillIntegrationMessageActions } from './elements/BillIntegrationMessageActions'
import { HStack } from './elements/styles'

export const BillIntegrationStatusMessage = (): ReactElement | null => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { billData } = useBillView()

  const integrationStatus = getLatestIntegrationStatus(billData?.bill.integrationStatus)
  const messageKey = useBillIntegrationStatusMessageKey(integrationStatus)

  if (!integrationStatus || !organization?.isCegid) {
    return null
  }

  const { status } = integrationStatus

  const titleKey = cegidIntegrationStatusToTranslationKeys[status]
  const icon = cegidIntegrationStatusToIcon[status].icon
  const variant = cegidIntegrationStatusToMessageVariant[status]

  return (
    <>
      <SectionMessage variant={variant} icon={icon}>
        <HStack>
          <div>
            <Text inheritColor variant="h4">
              {t(titleKey)}
            </Text>

            {messageKey && (
              <Text inheritColor variant="bodyMD">
                {t(messageKey)}
              </Text>
            )}
          </div>
          <BillIntegrationMessageActions bill={billData?.bill} />
        </HStack>
      </SectionMessage>
      <Space size="s24" />
    </>
  )
}
